// extracted by mini-css-extract-plugin
export var lightColor = "tagline-module--lightColor--dd20b";
export var tagline = "tagline-module--tagline--819e8";